import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { Item, WithTooltip } from 'basic-components';
import { globalActions } from 'primary-components';

import { creatorSeriesActions } from 'actions/series';

import { Else, If, Then } from 'react-if';

const PatternItem = ({ isStartingResults, selectedItems }) => {
  const dispatch = useDispatch(),
        areSingleItemsSelected = useMemo(() => selectedItems.some(s => s.pattern === "false"), [selectedItems]),
        createPattern = useCallback(() => {
          dispatch(creatorSeriesActions.createPattern())
          dispatch(globalActions.getMessageStore()).success("Matching data added to the basket.")
        }, [dispatch]),
        createPatternWithToast = useCallback(() => {
          dispatch(globalActions.getToastsStore()).warning("To create a pattern you need to discard all your data selections. Do you want to proceed?", "Create pattern", {
              withCancel: false,
              confirmText: "Confirm",
              confirmAction: () => {
                dispatch(creatorSeriesActions.onChange(selectedItems.filter(i => i.pattern === "true"), "selectedSymbols"))
                createPattern()
              }
            })
        }, [createPattern, dispatch, selectedItems])

  return (
    <If condition={isStartingResults}>
      <Then>
        {() => (
          <WithTooltip
              data-place="bottom"
              text="Select filters to create a pattern"
          >
            <Item
                disabled={isStartingResults}
                onClick={areSingleItemsSelected ? createPatternWithToast : createPattern}
            >
              Create pattern
            </Item>
          </WithTooltip>
        )}
      </Then>
      <Else>
        {() => (
          <Item 
              disabled={isStartingResults}
              onClick={areSingleItemsSelected ? createPatternWithToast : createPattern}
          >
            Create pattern
          </Item>
        )}
      </Else>
    </If>
  )
}

PatternItem.propTypes ={
  isStartingResults: PropTypes.bool.isRequired,
  selectedItems: PropTypes.array.isRequired,
}

export default PatternItem;